import { useEffect, useState } from "react";
import { fetchCountries, downloadCountriesExcel } from "../Api/ViewCountry";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewCountry = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const data = await fetchCountries();
        setCountries(data || []);
      } catch (error) {
        toast.error("🛑 Error Fetching Countries");
      }
    };

    loadCountries();
  }, []);

  const handleDownload = async () => {
    try {
      const response = await downloadCountriesExcel();

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "CountriesData.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("🛑 Error downloading Excel file");
    }
  };

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="list-title">View Countries</span>
            <Button className="generate-btn" variant="primary" onClick={handleDownload}>
              Download Data
            </Button>
          </div>

          {countries.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Country Code</th>
                      <th>Country Name</th>
                      <th>Created On</th>
                      <th>Created By</th>
                      <th>Changed On Date</th>
                      <th>Changed On Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {countries.map((country, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{country.countryCode}</td>
                        <td>{country.countryName}</td>
                        <td>
                          {country.createdOnDate
                            ? moment(country.createdOnDate).format("L") +
                              " " +
                              country.createdOnTime?.split(".")[0]
                            : "—"}
                        </td>
                        <td>{country.createdBy}</td>
                        <td>
                          {country.changedOnDate
                            ? moment(country.changedOnDate).format("L")
                            : "-"}
                        </td>
                        <td>
                          {country.changedOnTime
                            ? moment(country.changedOnTime, "HH:mm:ss.SSS").format("LTS")
                            : "-"}
                        </td>
                        <td>{country.changedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No countries found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewCountry;
